import { RootState } from '../../store';

export const getExpandedPaths = (state: RootState) => state.jsonViewer.expandedPaths;
export const getExpandedPath = (path: string) => (state: RootState) =>
  state.jsonViewer.expandedPaths?.[path] ?? false;
